const t = {
  name: "History",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 12C3 16.9777 7.02228 21 12 21C16.9777 21 21 16.9777 21 12C21 7.02228 16.9777 3 12 3C8.88184 3 6.13474 4.58776 4.52211 7H8V9H1V2H3V5.68368C4.98648 2.85334 8.27479 1 12 1C18.0823 1 23 5.91772 23 12C23 18.0823 18.0823 23 12 23C5.91772 23 1 18.0823 1 12H3Z" fill="currentColor"/>
<path d="M13 7V11.5858L17.4142 16L16 17.4142L11 12.4142V7H13Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as History
};
